<template>
  <li class="relative flex w-full card-image-links" :class="oneEveryRow ? 'w-full mb-6 md:mb-8' : twoEveryRow ? 'md:w-1/2 my-3 sm:px-3' : 'md:w-1/3 my-3 sm:px-3'">
    <div class="flex-1" :class="useWhiteBg ? 'bg-white' : 'bg-gray-ultralight'">
      <a :href="linkUrl" class="flex flex-col h-full group focus:outline-black-alt" :class="oneEveryRow ? 'md:flex-row' : ''">
        <div v-if="imageUrl" class="overflow-hidden" :class="oneEveryRow ? 'md:max-w-sm-medium' : ''">
          <img class="flex-none object-cover w-full transition duration-500 ease-out transform group-hover:scale-105" :src="imageUrl" />
        </div>
        <div
          class="flex flex-col items-baseline flex-grow w-full"
          :class="[noPaddingX ? 'px-0' : 'px-4', oneEveryRow ? 'pt-6 md:py-0 md:pl-6 justify-center' : 'py-6', company && companyType === 1 ? 'bg-gray-green !px-5' : company && companyType === 2 ? 'bg-gray-ultralight  !px-5' : ''].join(' ')">
          <div v-if="heading">
            <p class="mb-2 md:mb-0 font-futuraEfDemiBold" :class="largeHeading ? 'text-3xl' : 'text-xl'">
              {{ getStringWithoutLastWord(heading) }} <span class="web-link-icon">{{ getLastWordOfString(heading) }} </span>
            </p>
          </div>
          <p v-if="date" class="mb-2 leading-4 md:mb-0 text-green-dark md:leading-10 font-futuraEfDemiBold">
            <time class="pr-2 mr-2 border-r-2 border-green-dark font-futuraEfDemiBold" :datetime="date">{{ dateText }}</time
            >{{ tag }}
          </p>
          <p v-if="heading" class="text-xl" :class="lineClamp ? 'md:line-clamp-2' : ''">{{ text }}</p>
          <p v-if="!heading" class="text-2xl">
            {{ getStringWithoutLastWord(text) }} <span class="web-link-icon web-link-icon--small">{{ getLastWordOfString(text) }} </span>
          </p>
          <p v-if="company" class="pt-5 text-base md:pt-3">{{ company }}</p>
        </div>
      </a>
    </div>
  </li>
</template>

<script>
export default {
  name: 'EllevioWebCardImageItem',
  props: {
    oneEveryRow: {
      type: Boolean,
      default: false
    },
    twoEveryRow: {
      type: Boolean,
      default: false
    },
    lineClamp: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    useWhiteBg: {
      type: Boolean,
      default: false
    },
    noPaddingX: {
      type: Boolean,
      default: false
    },
    largeHeading: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: ''
    },
    dateText: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String
    },
    linkUrl: {
      type: String
    },
    tag: {
      type: String,
      default: ''
    },
    company: {
      type: String,
      default: ''
    },
    companyType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getStringWithoutLastWord(str) {
      let words = str.split(' ')
      let lastWord = words.pop()
      while (lastWord === '' && words.length > 0) {
        lastWord = words.pop()
      }
      return words.join(' ')
    },
    getLastWordOfString(str) {
      let words = str.split(' ')
      let lastWord = words.pop()
      while (lastWord === '' && words.length > 0) {
        lastWord = words.pop()
      }
      return lastWord
    }
  }
}
</script>
